import { render, staticRenderFns } from "./cadastro_novo_unidade.vue?vue&type=template&id=58d42cb0&scoped=true&"
import script from "./cadastro_novo_unidade.vue?vue&type=script&lang=js&"
export * from "./cadastro_novo_unidade.vue?vue&type=script&lang=js&"
import style0 from "./cadastro_novo_unidade.vue?vue&type=style&index=0&id=58d42cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d42cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VProgressCircular,VTextField})
